export default function setHeaderHeight(isSupervision?: boolean): void {
  const root: HTMLElement = document.querySelector(':root')!;
  const defaultHeaderHeight = getComputedStyle(root).getPropertyValue('--header-default-height');
  const supervisionNotificationHeight = getComputedStyle(root).getPropertyValue('--supervision-notification-height');
  const unitedHeight = `${Number.parseInt(defaultHeaderHeight, 10) + Number.parseInt(supervisionNotificationHeight, 10)}px`;

  root.style.setProperty('--header-height', isSupervision ? unitedHeight : defaultHeaderHeight);
}
